// Mutations
export const TOGGLE_COLLAPSE = 'core.toggle_collapsed'
